<template>
  <el-row v-if="pageControl.accessAllowed">

    <!-- Upload Attachments Dialog -->
    <upload-dialog :appCode="pageParams.appCode" :title="dialogData.uploadAttachment.title" ref="uploadAttachmentsDialog"></upload-dialog>
    <!-- Choose Reasons Dialog -->
    <el-dialog :title="dialogData.chooseReason.title" :visible.sync="dialogData.chooseReason.visible" :close-on-click-modal="false" width="80%">
      <el-alert
        title="【操作提示】：请谨慎选择审批决定对应的原因，可选择多个"
        :closable="false"
        type="warning"
        show-icon />
      <div style="overflow: auto; height: 420px">
        <el-table stripe ref="reasonsTable" :data="dialogData.chooseReason.data" @selection-change="handleReasonsSelectionChange" size="mini">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column property="riskCode" label="所有原因项">
            <template slot-scope="scope">{{scope.row.riskCode}}-{{scope.row.belongName}}-{{scope.row.riskName}}</template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelCheckApproveReasons">取 消</el-button>
        <el-button type="primary" @click="dialogData.chooseReason.visible = false">确 定</el-button>
      </div>
    </el-dialog>
    <!-- Point Final Approver Dialog -->
    <el-dialog :title="dialogData.pointFinalApproverDialog.title" :visible.sync="dialogData.pointFinalApproverDialog.visible" :close-on-click-modal="false" width="80%">
      <el-alert
        title="【操作提示】：此处选择的审批人会处理当前这个订单。"
        :closable="false"
        type="warning"
        show-icon />
      <div style="overflow: auto; height: 420px">
        <el-table stripe ref="pointFinalApproverTable" :data="dialogData.pointFinalApproverDialog.data" size="mini">
          <el-table-column type="index"></el-table-column>
          <el-table-column property="trueName" label="姓名"></el-table-column>
          <el-table-column property="modelId" label="操作">
            <template slot-scope="scope">
              <el-button type="text" icon="el-icon-check" size="mini" @click="handleCheckFinalApprover(scope.row)">选择</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogData.pointFinalApproverDialog.visible = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- C300 GetVinInfo Dialog -->
    <el-dialog :title="dialogData.getC300VinInfo.title" :visible.sync="dialogData.getC300VinInfo.visible" :close-on-click-modal="false" width="80%">
      <el-alert
        title="【提示】：此列表是根据订单vin号，调用车300供应商接口，获取的车型识别数据。"
        :closable="false"
        type="info"
        show-icon />
      <div style="overflow: auto; height: 420px">
        <el-table stripe ref="c300VinInfoTable" :data="dialogData.getC300VinInfo.data" size="mini">
          <el-table-column type="index"></el-table-column>
          <el-table-column property="modelName" label="车型"></el-table-column>
          <el-table-column property="modelPrice" label="新车指导价(万元)"></el-table-column>
          <el-table-column property="modelId" label="操作">
            <template slot-scope="scope">
              <el-button type="text" icon="el-icon-check" size="mini" @click="handleCheckVinInfo(scope.row)">选择</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelCheckVinInfo">取 消</el-button>
      </div>
    </el-dialog>
    <!-- C300 GetEvaluationPrice Dialog -->
    <el-dialog :title="dialogData.getC300EvaluationPrice.title" :visible.sync="dialogData.getC300EvaluationPrice.visible" :close-on-click-modal="false" width="80%">
      <el-alert
        title="【提示】：此列表是根据订单信息，调用车300供应商接口，获取的车辆估值数据。"
        :closable="false"
        type="info"
        show-icon />
      <div style="overflow: auto; height: 420px">
        <el-table stripe ref="c300EvaluationPriceTable" :data="dialogData.getC300EvaluationPrice.data" @selection-change="handleEvaluationPriceSelectionChange" size="mini">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column property="assessTypeName" label="数据来源"></el-table-column>
          <el-table-column property="goodReference" label="车况好（万元）"></el-table-column>
          <el-table-column property="normalReference" label="车况正常（万元）"></el-table-column>
          <el-table-column property="badReference" label="车况差（万元）"></el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogData.getC300EvaluationPrice.visible = false">确 定</el-button>
        <el-button @click="cancelCheckEvaluationPrice">取 消</el-button>
      </div>
    </el-dialog>
    <!-- Choose Gps Approve Status Dialog -->
    <el-dialog :title="dialogData.chooseGpsStatus.title" :visible.sync="dialogData.chooseGpsStatus.visible" :close-on-click-modal="false" width="80%">
      <el-alert
        title="【操作提示】：每个gps最多选5个；选择【审核通过】时不能选择其他选项。"
        :closable="false"
        type="warning"
        show-icon />
      <div style="overflow: auto; height: 420px">
        <el-table stripe ref="chooseGpsStatusTable" :data="dialogData.chooseGpsStatus.data" @selection-change="handleGpsStatusSelectionChange" size="mini">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column property="value" label="审核状态列表"></el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleGpsStatusSelectionSave">确 定</el-button>
        <el-button @click="dialogData.chooseGpsStatus.visible = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- Insure Scanning Files Status Dialog -->
    <el-dialog :title="dialogData.insureScanningFiles.title" :visible.sync="dialogData.insureScanningFiles.visible" :close-on-click-modal="false" width="80%">
      <el-alert
        title="【操作提示】：点击操作栏中的按钮，进行“确认收到”和“取消确认”操作"
        :closable="false"
        type="warning"
        show-icon />
      <div style="overflow: auto; height: 420px">
        <el-table stripe ref="insureScanningFilesTable" :data="dialogData.insureScanningFiles.data" size="mini">
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column property="infoName" label="资料名称"></el-table-column>
          <el-table-column property="confirmTime" label="确认时间">
            <template slot-scope="scope">{{scope.row.confirmTime | formatterDate}}</template>
          </el-table-column>
          <el-table-column label="确认状态">
            <template slot-scope="scope">
              <el-tag type="info" size="mini" v-if="!scope.row.insured">未确认</el-tag>
              <el-tag type="success" size="mini" v-if="scope.row.insured">已确认</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="success" size="mini" v-if="!scope.row.insured" @click="opInsureScanningFiles(scope.row)">确认收到</el-button>
              <el-button type="danger" size="mini" v-if="scope.row.insured" @click="opInsureScanningFiles(scope.row)">取消收到</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveInsureScanningFilesTable">确定并保存</el-button>
        <el-button @click="dialogData.insureScanningFiles.visible = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- Favorite Dialog -->
    <el-dialog :title="dialogData.favorite.title + ' [' + pageParams.appCode + ']'" :visible.sync="dialogData.favorite.visible" :fullscreen="true">
      <div  class="viewData">
        <el-form label-width="180px">
        <el-card name="FavoriteBase">
          <div slot="header" class="card-title">
            <bd-card-title text="基础信息"></bd-card-title>
          </div>
          <el-row :gutter="20" type="flex" justify="center">
            <el-col :span="11">
              <el-form-item label="城市门店">
                <el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.dealerName">
                  <span slot="append" class="color-important">{{pageData.orderBaseInfo.dealerCityName}}</span>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="所属销售人"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.belongSaleName"></el-input></el-form-item>
            </el-col>
          </el-row>
        </el-card>
        <el-card name="FavoriteCustomer">
          <div slot="header" class="card-title">
            <bd-card-title text="客户信息"></bd-card-title>
          </div>
          <el-row :gutter="20" type="flex" justify="center">
            <el-col :span="11">
              <el-form-item label="客户姓名" prop="orderProppserInfo.proppserName">
                <el-input :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.orderProppserInfo.proppserName"></el-input>
              </el-form-item>
              <el-form-item label="证件号码">
                <el-input :readonly="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.orderProppserInfo.idno">
                  <i slot="suffix" class="el-input__icon el-icon-view dcrypt-eye" v-if="pageControl.eyes.proposer.idno" @click="encryptionData(encryptionType.proposer.idno, pageData.orderProppserInfo, encryptionType.proposer.eyeOwner)"></i>
                </el-input>
              </el-form-item>
              <el-form-item label="证件有效期">
                <el-date-picker
                  style="width: 100%"
                  v-model="pageData.orderProppserInfo.idCardValidEndDate"
                  disabled
                  type="date"
                  placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="手机号码">
                <el-input :readonly="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.orderProppserInfo.mobile">
                  <i slot="suffix" class="el-input__icon el-icon-view dcrypt-eye" v-if="pageControl.eyes.proposer.mobile" @click="encryptionData(encryptionType.proposer.mobile, pageData.orderProppserInfo, encryptionType.proposer.eyeOwner)"></i>
                </el-input>
                <el-tag v-if="pageData.riskInfo.mobileCheck !== null && pageControl.current.operateTypePreview">{{pageData.riskInfo.mobileCheck}}</el-tag>
              </el-form-item>
              <el-form-item label="银行卡预留手机">
                <el-input :readonly="pageControl.current.operateTypePreview" v-model="pageData.orderLoanInfo.repAccountMobile">
                  <i slot="suffix" class="el-input__icon el-icon-view dcrypt-eye" v-if="pageControl.eyes.repAccountMobile" @click="encryptionData(encryptionType.repAccountMobile, pageData.orderLoanInfo)"></i>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" type="flex" justify="center">
            <el-col :span="11">
              <el-form-item label="还款借记卡开户行"><el-input disabled v-model="pageData.orderLoanInfo.repAccountBank"></el-input></el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="还款借记卡号">
                <el-input :readonly="pageControl.current.operateTypePreview" v-model="pageData.orderLoanInfo.repAccountNo">
                  <i slot="suffix" class="el-input__icon el-icon-view dcrypt-eye" v-if="pageControl.eyes.repAccountNo" @click="encryptionData(encryptionType.repAccountNo, pageData.orderLoanInfo)"></i>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
        <el-card name="FavoriteSales">
          <div slot="header" class="card-title">
            <bd-card-title text="经销商信息"></bd-card-title>
          </div>
          <el-row :gutter="20" type="flex" justify="center">
            <el-col :span="11">
              <el-form-item label="客户所属车商门店"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.belongDealerName"></el-input></el-form-item>
              <el-form-item label="收款账户姓名"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderLoanAccountInfo.recAccountName"></el-input></el-form-item>
              <el-form-item label="收款账户证件号码">
                <el-input :readonly="pageControl.current.operateTypePreview" v-model="pageData.orderLoanAccountInfo.recAccountCard">
                  <i slot="suffix" class="el-input__icon el-icon-view dcrypt-eye" v-if="pageControl.eyes.recAccountCard" @click="encryptionData(encryptionType.recAccountCard, pageData.orderLoanAccountInfo)"></i>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="收款开户银行"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderLoanAccountInfo.recAccountBank2"></el-input></el-form-item>
              <el-form-item label="收款开户支行"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderLoanAccountInfo.recAccountBank"></el-input></el-form-item>
              <el-form-item label="收款借记卡号">
                <el-input :readonly="pageControl.current.operateTypePreview" v-model="pageData.orderLoanAccountInfo.recAccountNo">
                  <i slot="suffix" class="el-input__icon el-icon-view dcrypt-eye" v-if="pageControl.eyes.recAccountNo" @click="encryptionData(encryptionType.recAccountNo, pageData.orderLoanAccountInfo)"></i>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
        <el-card name="FavoriteVehicle">
          <div slot="header" class="card-title">
            <bd-card-title text="车辆信息"></bd-card-title>
          </div>
          <el-row :gutter="20" type="flex" justify="center">
            <el-col :span="11">
              <el-form-item label="品牌"><el-input :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.orderCarInfo.carBrand"></el-input></el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="车辆颜色" prop="orderCarInfo.carColor">
                <el-select :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderCarInfo.carColor">
                  <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['车辆颜色']" :key="value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" type="flex" justify="center">
            <el-col :span="22">
              <el-form-item label="款式"><el-input :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" type="textarea" :rows="2" v-model="pageData.orderCarInfo.carStyles"></el-input></el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" type="flex" justify="center">
            <el-col :span="11">
              <el-form-item label="车辆识别代号">
                <el-input :readonly="pageControl.current.operateTypePreview || pageControl.current.operateTypeApprove" v-model="pageData.orderCarInfo.carIdentify">
                  <i slot="suffix" class="el-input__icon el-icon-view dcrypt-eye" v-if="pageControl.eyes.carIdentify" @click="encryptionData(encryptionType.carIdentify, pageData.orderCarInfo)"></i>
                </el-input>
                <el-button type="primary" size="mini" v-if="pageControl.current.operateTypeModify" @click="showVinInfoDialog">车300车型识别</el-button>
              </el-form-item>
              <el-form-item label="首次上牌时间" prop="orderCarInfo.carFirstBook">
                <el-date-picker
                  style="width: 100%"
                  disabled
                  v-model="pageData.orderCarInfo.carFirstBook"
                  value-format="timestamp"
                  type="date"
                  placeholder="请选择"
                  format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="发动机号"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderCarInfo.engineNo"></el-input></el-form-item>
            </el-col>
          </el-row>
        </el-card>
        <el-card name="FavoriteContract">
          <div slot="header" class="card-title">
            <bd-card-title text="合同详情"></bd-card-title>
          </div>
          <el-row :gutter="20" type="flex" justify="center">
            <el-col :span="11">
              <el-form-item label="实际销售价"><el-input disabled v-model="pageData.orderLoanInfo.salePrice"><span slot="append">元</span></el-input></el-form-item>
              <el-form-item label="批复总贷款金额"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.rLoanAmount"><span slot="append">（车辆+其他）</span></el-input></el-form-item>
              <el-form-item label="月供(仅供参考)">
                <el-input :disabled="pageControl.current.operateTypePreview" v-model="pageHelperData.form.monthPay">
                  <el-button slot="append" type="primary" plain size="mini" @click="handleMonthPayClick">计算</el-button>
                </el-input>
              </el-form-item>
              <el-form-item label="批复车辆贷款金额"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.rCarloanAmount"></el-input></el-form-item>
              <el-form-item label="批复平台费">
                <el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.rComFee">
                  <span slot="append" class="color-important">返佣金额:({{pageData.orderBaseInfo.serFinRebate}})</span>
                </el-input>
              </el-form-item>
              <el-form-item label="批复保险贷款金额"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.rSecureFee"></el-input></el-form-item>
              <el-form-item label="批复账户管理费"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.rAccountFee"></el-input></el-form-item>
              <el-form-item label="收款金额(车商)"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.dealerAmt"></el-input></el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="批复申请首付款"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.rInitPayment"></el-input></el-form-item>
              <el-form-item label="批复申请还款期限"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.rLoanPeriods"><span slot="append">个月</span></el-input></el-form-item>
              <el-form-item label="批复申请贷款年利率"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.rLoanRate"><span slot="append">%</span></el-input></el-form-item>
              <el-form-item label="批复申请GPS费用">
                <el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.rGpsFee">
                  <span slot="append" class="color-important">返佣金额:({{pageData.orderBaseInfo.gpsRebate}})</span>
                </el-input>
              </el-form-item>
              <el-form-item label="车享包费用"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageHelperData.contract.carSharePrice"></el-input></el-form-item>
              <el-form-item label="保险贷款金额"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderLoanInfo.aSecureFee"></el-input></el-form-item>
              <el-form-item label="批复购置税"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.rTaxPrice"></el-input></el-form-item>
              <el-form-item label="融资总额"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageHelperData.contract.totalFinancing"></el-input></el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" type="flex" justify="center">
            <el-col :span="11">
              <el-form-item label="车损盗抢最低额">
                <el-input :disabled="pageControl.current.operateTypePreview" v-model="pageHelperData.contract.damageLessPrice"></el-input>
                <el-tag type="success" size="mini">“实际销售价”与“二手车评估价” 二者取低的75%</el-tag>
              </el-form-item>
            </el-col>
            <el-col :span="11"></el-col>
          </el-row>
          <el-row :gutter="20" type="flex" justify="center">
            <el-col :span="22">
              <el-form-item label="特别批注"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageHelperData.contract.specialRemarks" type="textarea" :rows="4"></el-input></el-form-item>
            </el-col>
          </el-row>
        </el-card>
        <el-card name="FavoritePufa">
          <div slot="header" class="card-title">
            <bd-card-title text="浦发字段"></bd-card-title>
          </div>
          <el-row :gutter="20" type="flex" justify="center">
            <el-col :span="11">
              <el-form-item label="营销人员代码"><el-input :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.spdBusinessInfo.marketerCode"></el-input></el-form-item>
              <el-form-item label="现居住地址"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderProppserInfo.nowAddress"></el-input></el-form-item>
              <el-form-item label="现工作单位名称"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.proppserWorkInfo.nowCompany"></el-input></el-form-item>
              <el-form-item label="现工作单位地址"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.proppserWorkInfo.nowUnitAddress"></el-input></el-form-item>
              <el-form-item label="现工作单位固话"><el-input :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.spdBusinessInfo.workTel"></el-input></el-form-item>
              <el-form-item label="现工作单位电话"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.proppserWorkInfo.nowUnitTel"></el-input></el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="领用合约代码"><el-input :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.spdBusinessInfo.applicationagreementbarcode"></el-input></el-form-item>
              <el-form-item label="浦发信用卡产品">
                <el-select :disabled="pageControl.current.operateTypePreview" v-model="pageData.spdBusinessInfo.cardProductCode">
                  <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['浦发信用卡产品']" :key="value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="推荐人代码"><el-input :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.spdBusinessInfo.referenceCode"></el-input></el-form-item>
              <el-form-item label="申请人邮箱"><el-input :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.spdBusinessInfo.email"></el-input></el-form-item>
              <el-form-item label="申请人开卡城市">
                <el-select :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.spdBusinessInfo.cityCodeStr">
                  <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['市']" :key="value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="推荐人机构代码"><el-input :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.spdBusinessInfo.referenceJgcode"></el-input></el-form-item>
            </el-col>
          </el-row>
        </el-card>
        <el-card name="FavoriteGuarantee">
          <div slot="header" class="card-title">
            <bd-card-title text="担保人"></bd-card-title>
          </div>
          <el-row :gutter="20" type="flex" justify="center">
            <el-col :span="11">
              <el-form-item label="是否配偶共签">
                <el-select :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.isSpouseSign">
                  <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['是否']" :key="key"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="配偶姓名"><el-input :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.orderRelativeInfo.relativesName"></el-input></el-form-item>
              <el-form-item label="配偶证件号码">
                <el-input :readonly="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.orderRelativeInfo.idno">
                  <i slot="suffix" class="el-input__icon el-icon-view dcrypt-eye" v-if="pageControl.eyes.relative.idno" @click="encryptionData(encryptionType.relative.idno, pageData.orderRelativeInfo, encryptionType.relative.eyeOwner)"></i>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="是否担保共签">
                <el-select :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.isGuaranteedSign">
                  <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['是否']" :key="key"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="担保人姓名"><el-input :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.guaranteeInfo.guaranteeName"></el-input></el-form-item>
              <el-form-item label="担保人证件号码">
                <el-input :readonly="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.guaranteeInfo.idno">
                  <i slot="suffix" class="el-input__icon el-icon-view dcrypt-eye" v-if="pageControl.eyes.guarantee.idno" @click="encryptionData(encryptionType.guarantee.idno, pageData.guaranteeInfo, encryptionType.guarantee.eyeOwner)"></i>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
      </el-form>
      </div>
    </el-dialog>

    <!-- Head Info -->
    <div name="HeadInfo">
      <!-- Approval Step Display -->
      <el-row v-if="(pageControl.current.operateTypePreview || pageControl.current.operateTypeApprove) && !pageControl.current.forSearch">
        <el-col :span="24">
          <el-steps :active="pageControl.current.approvalStep" finish-status="success" align-center simple>
            <el-step v-for="approveStepName in pageControl.approveStep.names" :key="approveStepName.value" :title="approveStepName.value"></el-step>
          </el-steps>
        </el-col>
      </el-row>
      <!-- Page Title -->
      <el-card>
        <div>
          <!-- Text -->
          <span style="font-weight: bold">{{pageTitle.current}} [{{pageParams.appCode}}]</span>
          <!-- Buttons -->
          <!-- return button -->
          <div style="float: right; margin-top: -8px; margin-right: 20px;">
            <el-button type="primary" @click="handleClickReturnButton">返回</el-button>
          </div>
          <!--<el-button @click="handleClickReturnButton" style="float: right; padding: 12px 20px; margin-top: -8px; margin-left: 20px;" type="primary">返回</el-button>-->
          <!-- approve button -->
          <div style="float: right; margin-top: -8px; margin-right: 20px;" v-if="pageControl.current.operateTypeApprove">
            <el-button type="primary" plain @click="resetApproveForm" v-if="!pageControl.current.approvalStepGps">重置</el-button>
            <el-button type="primary" plain @click="submitApproveForm">提交</el-button>
            <el-button type="primary" plain @click="showUploadAttachment" v-if="!pageControl.current.approvalStepGps">上传审批附件</el-button>
            <!-- modify button -->
            <el-button type="primary" plain v-if="pageControl.current.approvalStepReview && pageControl.current.operateTypeApprove" @click="handleClickModifyButton">编辑</el-button>
          </div>
          <!-- save button | edit -->
          <div style="float: right; margin-top: -8px; margin-right: 20px;" v-if="pageControl.current.operateTypeModify">
            <el-button type="primary" plain @click="submitModifyForm">保存</el-button>
          </div>
          <div style="float: right; margin-top: -8px; margin-right: 20px;">
            <!-- details button -->
            <el-button type="text" v-if="pageControl.current.operateTypePreview" @click="clickShowDetailsButton">{{cardConfig.detailButton.text.current}}</el-button>
            <!-- collapse button -->
            <el-button type="text" v-if="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" @click="clickCollapseAllButton">{{cardConfig.collapseButton.text.current}}</el-button>
          </div>
        </div>
      </el-card>
    </div>

    <!-- Main Info -->
    <el-container style="margin-top: -20px;">
      <el-main>
        <!-- Approve Operate -->
        <el-form :model="approveData.form" :rules="approveData.rules.current" :validate-on-rule-change="false" ref="approveForm" v-if="pageControl.current.operateTypeApprove && !pageControl.current.approvalStepMortgage" label-width="180px">
          <!-- CA Main Step Approve -->
          <el-card name="MainApproveInfo" v-if="!(pageControl.current.approvalStepGps || pageControl.current.forSearch || pageControl.current.approvalStepMortgage)">
            <div slot="header" class="card-title" @click="cardTitleClickHandler(cardConfig.approveInfo)">
              <bd-card-title :text="cardConfig.approveInfo.title.text" :btn-class="cardConfig.approveInfo.title.btnClass"></bd-card-title>
            </div>
            <!-- Main Approve Info | approveInfo -->
            <div v-if="cardConfig.approveInfo.visible">
              <!-- Decision Type Radio Button -->
              <el-row :gutter="20" type="flex" justify="center">
                <el-col :span="22">
                  <el-form-item label="审批决定" prop="type">
                    <el-radio-group v-model="approveData.form.type" @change="handleApprovalTypeChange">
                      <el-radio v-for="(key, value) in approveData.currentDecisionArray" :key="key" :label="value">{{key}}</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- Decision Type | Pass -->
              <div v-if="!pageControl.current.approvalStepContract" v-show="approveData.form.type === approveData.decisionType.pass">
                <el-row :gutter="20" type="flex" justify="center" v-if="pageControl.current.approvalStepReview || pageControl.current.approvalStepFinal">
                  <el-col :span="11">
                    <el-form-item label="通过类型" prop="passType">
                      <el-select  placeholder="请选择通过类型" v-model="approveData.form.passType">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['通过类型']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item label="通过原因" prop="riskCode">
                      <el-input  placeholder="请选择通过原因" v-model="approveData.form.riskCode" readonly>
                        <el-button slot="append" icon="el-icon-zoom-in" @click="showCheckApproveReasons('pass')"></el-button>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <!-- Decision Type | Refuse -->
              <div v-if="(approveData.form.type === approveData.decisionType.refuse && !pageControl.current.approvalStepReconsider) || approveData.form.type === approveData.decisionType.reconsiderPass">
                <el-row :gutter="20" type="flex" justify="center">
                  <el-col :span="11">
                    <el-form-item label="拒绝类型" prop="refuseType">
                      <el-select  placeholder="请选择拒绝类型" v-model="approveData.form.refuseType">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['拒绝类型']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item label="拒绝原因" prop="riskCode">
                      <el-input  placeholder="请选择通过原因" v-model="approveData.form.riskCode" readonly>
                        <el-button slot="append" icon="el-icon-zoom-in" @click="showCheckApproveReasons('refuse')"></el-button>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <!-- Decision Type | Cancel -->
              <div v-if="approveData.form.type === approveData.decisionType.cancel">
                <el-row :gutter="20" type="flex" justify="center">
                  <el-col :span="11">
                    <el-form-item label="取消类型" prop="cancelType">
                      <el-select  placeholder="请选择取消类型" v-model="approveData.form.cancelType">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['取消类型']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item label="取消原因" prop="riskCode">
                      <el-input  placeholder="请选择取消原因" v-model="approveData.form.riskCode" readonly>
                        <el-button slot="append" icon="el-icon-zoom-in" @click="showCheckApproveReasons('cancel')"></el-button>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <!-- Decision Type | BackToSales -->
              <div v-if="approveData.form.type === approveData.decisionType.backToSales && !pageControl.current.approvalStepMortgage">
                <el-row :gutter="20" type="flex" justify="center">
                  <el-col :span="11">
                    <el-form-item label="退回类型" prop="backCode">
                      <el-select  placeholder="请选择退回类型" v-model="approveData.form.backCode" @change="handleBackTypeChange">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['退回经销商类型']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item label="退回原因" prop="backReason" readonly>
                      <el-input v-model="approveData.form.backReason"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <!-- Decision Type | BackToPrevious -->
              <div v-if="(pageControl.current.approvalStepContract || pageControl.current.approvalStepFinal) && approveData.form.type === approveData.decisionType.backToPrevious">
                <el-row :gutter="20" type="flex" justify="center">
                  <el-col :span="11">
                    <el-form-item label="退回类型" prop="backReasonBackToPrevious">
                      <el-select  placeholder="请选择退回类型" v-model="approveData.form.backReasonBackToPrevious" @change="handleBackTypeBackToPrevious">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['退回复审退回类型']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="11">
                  </el-col>
                </el-row>
              </div>
              <!-- Remarks -->
              <el-row :gutter="20" type="flex" justify="center">
                <el-col :span="22">
                  <el-form-item label="审批意见">
                    <el-input type="textarea" :rows="2" v-model="approveData.form.remarks"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- 批复信息块（复审 & 终审） -->
              <el-row :gutter="20" type="flex" justify="center" v-if="pageControl.current.approvalStepReview || pageControl.current.approvalStepFinal" v-show="approveData.form.type === approveData.decisionType.pass || approveData.form.type === approveData.decisionType.refuse">
                <el-col :span="11">
                  <el-form-item label="批复申请车辆贷款金额(元)">
                    <el-input v-model="pageData.orderBaseInfo.rCarloanAmount" @blur="handleCalculateFee"></el-input>
                  </el-form-item>
                  <el-form-item label="批复账户管理费金额(元)"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.rAccountFee"></el-input></el-form-item>
                  <el-form-item label="批复平台费金额(元)"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.rComFee"></el-input></el-form-item>
                  <el-form-item label="批复申请GPS费用"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.rGpsFee"></el-input></el-form-item>
                  <el-form-item label="批复申请首付款"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.rInitPayment"></el-input></el-form-item>
                  <el-form-item label="批复贴息金额(若有贴息)"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.rDiscountTrueE"></el-input></el-form-item>
                  <el-form-item label="批复购置税"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.rTaxPrice"></el-input></el-form-item>
                  <el-form-item label="批复交强险"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.rTrafficInsurance"></el-input></el-form-item>
                  <el-form-item label="批复保险贷款金额"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.rSecureFee"></el-input></el-form-item>
                  <el-form-item label="是否配偶共签">
                    <el-select :disabled="!pageControl.current.isMarried" v-model="pageData.orderBaseInfo.isSpouseSign">
                      <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['是否']" :key="key"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="批复申请还款期限(月)">
                    <el-select v-model="pageData.orderBaseInfo.rLoanPeriods" @change="handleCalculateFee">
                      <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['还款期限']" :key="value"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="批复利率档位">
                    <el-select v-model="pageData.orderBaseInfo.rRateLevel">
                      <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['利率档位']" :key="key"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="批复第二年保险费金额(元)"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.rYanbaoFee"></el-input></el-form-item>
                  <el-form-item label="批复申请贷款年利率(%)"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.rLoanRate"></el-input></el-form-item>
                  <el-form-item label="批复申请首付款比例(%)"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.rInitScale"></el-input></el-form-item>
                  <el-form-item label="批复延保费金额(元)"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.rExtendCost"></el-input></el-form-item>
                  <el-form-item label="批复商业险"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.rBusinessInsurance"></el-input></el-form-item>
                  <el-form-item label="是否担保共签">
                    <el-select :disabled="!pageControl.current.hasGuaranteeInfo" v-model="pageData.orderBaseInfo.isGuaranteedSign">
                      <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['是否']" :key="key"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="月供(仅供参考)">
                    <el-input :disabled="pageControl.current.operateTypePreview" v-model="pageHelperData.form.monthPay">
                      <el-button slot="append" type="primary" plain size="mini" @click="handleMonthPayClick">计算</el-button>
                    </el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" plain @click="handleSaveReplyData">保存批复信息</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- 签约审批信息块 -->
              <el-row :gutter="20" type="flex" justify="center" v-if="pageControl.current.approvalStepContract" v-show="approveData.form.type === approveData.decisionType.pass">
                <el-col :span="11">
                  <el-form-item label="第1车网查询结果" prop="carResult">
                    <el-select  placeholder="请选择" v-model="approveData.form.carResult">
                      <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['第一车网查询结果']" :key="key"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="有无信贷报告" prop="isCreditReport">
                    <el-select  placeholder="请选择" v-model="approveData.form.isCreditReport">
                      <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['有无']" :key="key"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="客户鉴权渠道" prop="authCh">
                    <el-select  placeholder="请选择" v-model="approveData.form.authCh">
                      <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['客户鉴权渠道']" :key="key"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="抵押合同模板" prop="pledModelId">
                    <el-select  placeholder="请选择" v-model="approveData.form.pledModelId">
                      <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['抵押合同模板']" :key="key"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="门店与产品">
                    <span style="color: #F56C6C;">{{pageData.orderBaseInfo.dealerName}}，{{pageData.orderBaseInfo.productName}}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="是否VIP合同" prop="isVipContract">
                    <el-select  placeholder="请选择" v-model="approveData.form.isVipContract">
                      <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['是否']" :key="key"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="渠道验证">
                    <span style="color: #F56C6C;">暂无验证渠道</span>
                  </el-form-item>
                  <el-form-item label="二手车过户日期">
                    <el-date-picker type="date" placeholder="请选择" format="yyyy-MM-dd" v-model="approveData.form.transferRegDate" style="width: 100%;"></el-date-picker>
                  </el-form-item>
                  <el-form-item label="已签贷款合同" prop="modelIds">
                    <el-checkbox-group v-model="approveData.form.modelIds">
                      <el-checkbox v-for="(key, value) in _enumStore.state['已签贷款合同']" :key="key" :label="value">{{key}}</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                  <el-form-item label="月供">
                    <el-input v-model="pageHelperData.form.monthPay">
                      <el-button slot="append" type="primary" plain size="mini" @click="handleMonthPayClick">计算</el-button>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-card>
          <!-- GPS Approve -->
          <el-card name="GpsApproveInfo" v-if="pageControl.current.approvalStepGps">
            <div slot="header" class="card-title" @click="cardTitleClickHandler(cardConfig.loanConfirmInfo)">
              <bd-card-title :text="cardConfig.loanConfirmInfo.title.text" :btn-class="cardConfig.loanConfirmInfo.title.btnClass"></bd-card-title>
            </div>
            <!-- GPS Approve Info | approveInfo -->
            <div v-if="cardConfig.loanConfirmInfo.visible">
              <el-table stripe ref="carGpsInfoTable" :data="pageData.carGpsInfoList" border size="mini">
                <el-table-column property="gpsDealer" label="GPS供应商" width="220px"></el-table-column>
                <el-table-column property="gpsInstallWay" label="安装方式" width="140px">
                  <template slot-scope="scope">
                    <el-select disabled v-model="scope.row.gpsInstallWay" size="mini">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['GPS安装方式']" :key="key"></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column property="gpsNo" label="GPS设备号" width="140px"></el-table-column>
                <el-table-column property="manualAuditResult" label="人工审核结果" style="max-width: 300px;">
                  <template slot-scope="scope">
                    <el-row :gutter="12" justify="center" type="flex">
                      <el-col :span="11">
                        <el-button type="primary" size="mini" icon="el-icon-circle-plus-outline" @click="showChooseGpsStatusDialog(scope.row)">请选择</el-button>
                      </el-col>
                      <el-col :span="11">
                        <el-button type="danger" size="mini" icon="el-icon-remove-outline" @click="cleanChoosenGpsStatus(scope.row)" v-if="scope.row.manualAuditResult!==null">清除</el-button>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col>{{scope.row.manualAuditResult}}</el-col>
                    </el-row>
                  </template>
                </el-table-column>
                <el-table-column property="auditSupplement" label="补充内容" style="max-width: 300px;">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.auditSupplement" type="textarea" :rows="2"></el-input>
                  </template>
                </el-table-column>
                <el-form-item slot="append" label="GPS安装确认" style="margin-top: 20px;" label-width="110px">
                  <el-checkbox checked disabled>已安装</el-checkbox>
                </el-form-item>
              </el-table>
            </div>
          </el-card>
        </el-form>
        <!-- Mortgage Approve Operate -->
        <el-form :model="approveData.formMortgage" :rules="approveData.rules.current" :validate-on-rule-change="false" ref="mortgageApproveForm" v-if="pageControl.current.operateTypeApprove && pageControl.current.approvalStepMortgage" label-width="180px">
          <!-- Mortgage Approve -->
          <el-card name="MortgageApproveInfo">
            <div slot="header" class="card-title" @click="cardTitleClickHandler(cardConfig.mortgageConfirmInfo)">
              <bd-card-title :text="cardConfig.mortgageConfirmInfo.title.text" :btn-class="cardConfig.mortgageConfirmInfo.title.btnClass"></bd-card-title>
            </div>
            <!-- Mortgage Approve Info | approveInfo -->
            <div v-if="cardConfig.mortgageConfirmInfo.visible">
              <el-row :gutter="20" type="flex" justify="center">
                <el-col :span="11">
                  <el-form-item label="抵押附件资料是否退回" prop="postLoanStatus">
                    <el-radio-group v-model="approveData.formMortgage.postLoanStatus" @change="handlePostLoanStatusChange">
                      <el-radio v-for="(key, value) in _enumStore.state['抵押附件资料是否退回']" :key="key" :label="value">{{key}}</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="退回原因" prop="cancelReason">
                    <el-input v-model="approveData.formMortgage.cancelReason"></el-input>
                  </el-form-item>
                  <el-form-item label="证件号码">
                    <el-input readonly v-model="approveData.formMortgage.idno"></el-input>
                  </el-form-item>
                  <el-form-item label="发动机号" prop="engineNo">
                    <el-input v-model="approveData.formMortgage.engineNo"></el-input>
                  </el-form-item>
                  <el-form-item label="车牌号" prop="plateNumber">
                    <el-input v-model="approveData.formMortgage.plateNumber"></el-input>
                  </el-form-item>
                  <el-form-item label="车辆识别代码" prop="carIdentify">
                    <el-input v-model="approveData.formMortgage.carIdentify"></el-input>
                  </el-form-item>
                  <el-form-item label="扫描件确认" prop="insured">
                    <el-checkbox v-model="approveData.formMortgage.insured" disabled>请确认</el-checkbox>
                    <el-button type="primary" size="mini" @click="showInsureScanningFilesDialog">点击确认扫描件资料</el-button>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="放款渠道与时间">
                    【{{approveData.formMortgage.paymentChZn}}】于【{{approveData.formMortgage.loanTime | formatterDate}}】放款
                  </el-form-item>
                  <el-form-item label="实际销售价（元）">
                    {{approveData.formMortgage.salePrice}}
                  </el-form-item>
                  <el-form-item label="批复车辆贷款金额（元）">
                    {{approveData.formMortgage.rCarloanAmount}}
                  </el-form-item>
                  <el-form-item label="发动机所有人">
                    {{pageData.orderProppserInfo.proppserName}}
                  </el-form-item>
                  <el-form-item label="车辆颜色">
                    <el-select v-model="approveData.formMortgage.carColor" disabled>
                      <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['车辆颜色']" :key="value"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="二手车过户日期" prop="transferRegDate">
                    <el-date-picker type="date" placeholder="请选择" format="yyyy-MM-dd" v-model="approveData.formMortgage.transferRegDate" style="width: 100%"></el-date-picker>
                  </el-form-item>
                  <el-form-item label="抵押日期" prop="mortgageDate">
                    <el-date-picker type="date" placeholder="请选择" format="yyyy-MM-dd" v-model="approveData.formMortgage.mortgageDate" style="width: 100%"></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20" justify="center" type="flex">
                <el-col :span="22">
                  <el-form-item label="备注">
                    <el-input v-model="approveData.formMortgage.loanAfterRemarks"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-form>

        <!-- 详情 | 受详情按钮控制 -->
        <div v-if="cardConfig.detailButton.showDetails" class="viewData">
          <!-- form data -->
          <el-form :model="pageData" :rules="pageMainForm.rules.current" label-width="180px" ref="refPageMainForm">
            <!-- Base Info | orderBaseInfo -->
            <el-card name="BaseInfo" v-if="!pageControl.current.operateTypeModify">
              <div slot="header" class="card-title" @click="cardTitleClickHandler(cardConfig.baseInfo)">
                <bd-card-title :text="cardConfig.baseInfo.title.text" :btn-class="cardConfig.baseInfo.title.btnClass"></bd-card-title>
              </div>
              <div v-show="cardConfig.baseInfo.visible">
                <el-row :gutter="20" type="flex" justify="center">
                  <el-col :span="11">
                    <!-- {{ pageData.orderBaseInfo.companyName | filterHtml }} -->
                    <el-form-item label="公司名称"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.companyName"></el-input></el-form-item>
                    <el-form-item label="所属市场"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.belongMarketName"></el-input></el-form-item>
                    <el-form-item label="所属销售人"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.belongSaleName"></el-input></el-form-item>
                    <el-form-item label="所属销售主管"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.belongSaleManagerName"></el-input></el-form-item>
                    <el-form-item label="审批流程">
                      <el-select  placeholder="请选择审批流程" :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.flowSeq">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['审批流程']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="车牌类型">
                      <el-select  placeholder="请选择车牌类型" :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.isCompanyLicense">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['公私牌']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item label="城市门店">
                      <el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.dealerName">
                        <span slot="append" class="color-important">{{pageData.orderBaseInfo.dealerCityName}}</span>
                      </el-input>
                    </el-form-item>
                    <el-form-item label="所属运营"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.belongOperationName"></el-input></el-form-item>
                    <el-form-item label="销售人手机号"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.belongSaleTel"></el-input></el-form-item>
                    <el-form-item label="客户所属车商门店"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.belongDealerName"></el-input></el-form-item>
                    <el-form-item label="贷款产品"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.productName"></el-input></el-form-item>
                    <el-form-item label="申请单来源"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.comeFromName"></el-input></el-form-item>
                  </el-col>
                </el-row>
                <!-- 根据流程阶段判断是否显示下边的数据，终审之前：隐藏；终审之后：显示 or 综合查询：显示 -->
                <el-row :gutter="20" type="flex" justify="center" v-if="pageControl.current.approvalStepAfterFinal || pageControl.current.forSearch">
                  <el-col :span="11">
                    <el-form-item label="批复总贷款金额"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.rLoanAmount"><span slot="append">（车辆+其他）</span></el-input></el-form-item>
                    <el-form-item label="批复车辆贷款金额"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.rCarloanAmount"></el-input></el-form-item>
                    <el-form-item label="批复申请GPS费用">
                      <el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.rGpsFee">
                        <span slot="append" class="color-important">返佣金额:({{pageData.orderBaseInfo.gpsRebate}})</span>
                      </el-input>
                    </el-form-item>
                    <el-form-item label="批复申请首付款"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.rInitPayment"></el-input></el-form-item>
                    <el-form-item label="批复保险贷款金额"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.rSecureFee"></el-input></el-form-item>
                    <el-form-item label="批复商业险"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.rBusinessInsurance"></el-input></el-form-item>
                    <el-form-item label="批复购置税"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.rTaxPrice"></el-input></el-form-item>
                    <el-form-item label="批复平台费">
                      <el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.rComFee">
                        <span slot="append" class="color-important">返佣金额:({{pageData.orderBaseInfo.serFinRebate}})</span>
                      </el-input>
                    </el-form-item>
                    <el-form-item label="批复贴息金额"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.rDiscountTrueE"></el-input></el-form-item>
                    <el-form-item label="是否配偶共签">
                      <el-select :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.isSpouseSign">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['是否']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="收款金额(车商)"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.dealerAmt"></el-input></el-form-item>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item label="批复申请还款期限"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.rLoanPeriods"><span slot="append">个月</span></el-input></el-form-item>
                    <el-form-item label="批复账户管理费"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.rAccountFee"></el-input></el-form-item>
                    <el-form-item label="批复申请贷款年利率"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.rLoanRate"><span slot="append">%</span></el-input></el-form-item>
                    <el-form-item label="批复申请首付款比例"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.rInitScale"><span slot="append">%</span></el-input></el-form-item>
                    <el-form-item label="批复交强险"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.rTrafficInsurance"></el-input></el-form-item>
                    <el-form-item label="批复延保费"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.rExtendCost"></el-input></el-form-item>
                    <el-form-item label="批复第二年保险费"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.rYanbaoFee"></el-input></el-form-item>
                    <el-form-item label="批复利率档位">
                      <el-select :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.rRateLevel">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['利率档位']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="是否担保共签">
                      <el-select :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.isGuaranteedSign">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['是否']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="收款金额(公司代扣费)"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.withholdAmt"></el-input></el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-card>
            <!-- Proposer Info | orderProppserInfo -->
            <el-card name="ProposerInfo">
              <div slot="header" class="card-title" @click="cardTitleClickHandler(cardConfig.proposerInfo)">
                <bd-card-title :text="cardConfig.proposerInfo.title.text" :btn-class="cardConfig.proposerInfo.title.btnClass"></bd-card-title>
              </div>
              <div v-show="cardConfig.proposerInfo.visible">
                <el-row :gutter="20" type="flex" justify="center">
                  <el-col :span="11">
                    <el-form-item label="申请人姓名" prop="orderProppserInfo.proppserName">
                      <el-input :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.orderProppserInfo.proppserName"></el-input>
                    </el-form-item>
                    <el-form-item label="性别">
                      <el-select :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.orderProppserInfo.sex">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['性别']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="手机号码">
                      <el-input :readonly="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.orderProppserInfo.mobile">
                        <i slot="suffix" class="el-input__icon el-icon-view dcrypt-eye" v-if="pageControl.eyes.proposer.mobile" @click="encryptionData(encryptionType.proposer.mobile, pageData.orderProppserInfo, encryptionType.proposer.eyeOwner)"></i>
                      </el-input>
                      <el-tag v-if="pageData.riskInfo.mobileCheck !== null && pageControl.current.operateTypePreview">{{pageData.riskInfo.mobileCheck}}</el-tag>
                    </el-form-item>
                    <el-form-item label="证件类型">
                      <el-select :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.orderProppserInfo.idType">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['证件类型']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="证件号码">
                      <el-input :readonly="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.orderProppserInfo.idno">
                        <i slot="suffix" class="el-input__icon el-icon-view dcrypt-eye" v-if="pageControl.eyes.proposer.idno" @click="encryptionData(encryptionType.proposer.idno, pageData.orderProppserInfo, encryptionType.proposer.eyeOwner)"></i>
                      </el-input>
                    </el-form-item>
                    <el-form-item label="证件有效期">
                      <el-date-picker
                        style="width: 100%"
                        v-model="pageData.orderProppserInfo.idCardValidEndDate"
                        disabled
                        type="date"
                        placeholder="选择日期">
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item label="生日">
                      <el-input :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.orderProppserInfo.birth" placeholder="请选择"></el-input>
                    </el-form-item>
                    <el-form-item label="是否有担保人">
                      <el-select :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.orderProppserInfo.isAssure">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['是否']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="婚姻状况">
                      <el-select :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.orderProppserInfo.marriage">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['婚姻状况']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="学历">
                      <el-select :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderProppserInfo.education">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['学历']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="从事行业">
                      <el-select :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderProppserInfo.nowIndustry">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['从事行业']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="职位">
                      <el-select :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderProppserInfo.nowPosition">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['职位']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                    <!-- 暂时不要收入来源 2018-06 -->
                    <el-form-item label="收入来源" v-if="!pageControl.current.operateTypeModify && false">
                      <el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderProppserInfo.incomeSource"></el-input>
                    </el-form-item>
                    <el-form-item label="税后月收入"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderProppserInfo.incomeMonth"><span slot="append">元</span></el-input></el-form-item>
                    <el-form-item label="紧急联系人"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderProppserInfo.eContact"></el-input></el-form-item>
                    <el-form-item label="紧急联系人手机号码">
                      <el-input :readonly="pageControl.current.operateTypePreview" v-model="pageData.orderProppserInfo.eContactMobile">
                        <i slot="suffix" class="el-input__icon el-icon-view dcrypt-eye" v-if="pageControl.eyes.eContactMobile" @click="encryptionData(encryptionType.eContactMobile, pageData.orderProppserInfo)"></i>
                      </el-input>
                    </el-form-item>
                    <el-form-item label="与紧急联系人关系">
                      <el-select :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderProppserInfo.relationEContact">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['紧急联系人关系']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item label="住房所有权">
                        <el-select :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderProppserInfo.houseOwner">
                          <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['住房所有权']" :key="key"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="户籍省/市/区">
                      <el-cascader
                        style="width: 100%"
                        :disabled="pageControl.current.operateTypePreview"
                        size="large"
                        :options="regionDataPlus"
                        v-model="pageHelperData.area.proposer.home"></el-cascader>
                    </el-form-item>
                    <el-form-item label="户籍地址"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderProppserInfo.address"></el-input></el-form-item>
                    <el-form-item label="现居省/市/区">
                      <el-cascader
                        style="width: 100%"
                        :disabled="pageControl.current.operateTypePreview"
                        size="large"
                        :options="regionDataPlus"
                        v-model="pageHelperData.area.proposer.now"></el-cascader>
                    </el-form-item>
                    <el-form-item label="现居住地址"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderProppserInfo.nowAddress"></el-input></el-form-item>
                    <el-form-item label="现居住时间"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderProppserInfo.nowLivingTime"><span slot="append">年</span></el-input></el-form-item>
                    <el-form-item label="现居住电话"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderProppserInfo.nowTel"></el-input></el-form-item>
                    <el-form-item label="现居住邮编"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderProppserInfo.nowPostalcode"></el-input></el-form-item>
                    <el-form-item label="驾驶员驾驶凭证">
                      <el-select :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderProppserInfo.isDriverLicense">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['驾驶员驾驶凭证']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="驾驶员与主贷人关系">
                      <el-select :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderProppserInfo.relationDFl">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['驾驶人关系']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="驾驶员准驾车型">
                      <el-select :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderProppserInfo.driverType">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['准驾车型']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="户口性质">
                      <el-select :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderProppserInfo.residenceNature">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['户口性质']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="紧急联系人2"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderProppserInfo.eContacts"></el-input></el-form-item>
                    <el-form-item label="紧急联系人2手机号码">
                      <el-input :readonly="pageControl.current.operateTypePreview" v-model="pageData.orderProppserInfo.eContactsMobile">
                        <i slot="suffix" class="el-input__icon el-icon-view dcrypt-eye" v-if="pageControl.eyes.eContactsMobile" @click="encryptionData(encryptionType.eContactsMobile, pageData.orderProppserInfo)"></i>
                      </el-input>
                    </el-form-item>
                    <el-form-item label="与紧急联系人2关系">
                      <el-select :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderProppserInfo.relationEContacts">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['紧急联系人关系']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-card>
            <!-- Work Background | proppserWorkInfo -->
            <el-card name="WorkBackground">
              <div slot="header" class="card-title" @click="cardTitleClickHandler(cardConfig.workBackground)">
                <bd-card-title :text="cardConfig.workBackground.title.text" :btn-class="cardConfig.workBackground.title.btnClass"></bd-card-title>
              </div>
              <div v-show="cardConfig.workBackground.visible">
                <el-row :gutter="20" type="flex" justify="center">
                  <el-col :span="11">
                    <el-form-item label="现工作单位名称"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.proppserWorkInfo.nowCompany"></el-input></el-form-item>
                    <el-form-item label="现工作单位省/市/区">
                      <el-cascader
                        style="width: 100%"
                        :disabled="pageControl.current.operateTypePreview"
                        size="large"
                        :options="regionDataPlus"
                        v-model="pageHelperData.area.proposer.work"></el-cascader>
                    </el-form-item>
                    <el-form-item label="现工作单位地址"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.proppserWorkInfo.nowUnitAddress"></el-input></el-form-item>
                    <el-form-item label="现工作单位年限"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.proppserWorkInfo.nowWorkYear"><span slot="append">年</span></el-input></el-form-item>
                    <el-form-item label="工作单位性质">
                      <el-select :disabled="pageControl.current.operateTypePreview" v-model="pageData.proppserWorkInfo.nowUnitKind">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['工作单位性质']" :key="value"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item label="现工作单位电话"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.proppserWorkInfo.nowUnitTel"></el-input></el-form-item>
                    <el-form-item label="现工作单位规模">
                      <el-select :disabled="pageControl.current.operateTypePreview" v-model="pageData.proppserWorkInfo.nowUnitScale">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['工作单位规模']" :key="value"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="参加工作时间">
                      <el-date-picker
                        style="width: 100%"
                        :disabled="pageControl.current.operateTypePreview"
                        v-model="pageData.proppserWorkInfo.firstWorkTime"
                        type="date"
                        placeholder="请选择"
                        format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="现工作单位邮编"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.proppserWorkInfo.nowUnitPostalcode"></el-input></el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-card>
            <!-- Relative Info | orderRelativeInfo -->
            <el-card name="RelativeInfo" v-if="pageControl.current.isMarried">
              <div slot="header" class="card-title" @click="cardTitleClickHandler(cardConfig.relativeInfo)">
                <bd-card-title :text="cardConfig.relativeInfo.title.text" :btn-class="cardConfig.relativeInfo.title.btnClass"></bd-card-title>
              </div>
              <div v-show="cardConfig.relativeInfo.visible">
                <el-row :gutter="20" type="flex" justify="center">
                  <el-col :span="11">
                    <el-form-item label="配偶姓名"><el-input :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.orderRelativeInfo.relativesName"></el-input></el-form-item>
                    <el-form-item label="配偶生日">
                      <el-input :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.orderRelativeInfo.birth"></el-input>
                    </el-form-item>
                    <el-form-item label="配偶证件类型">
                      <el-select :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.orderRelativeInfo.idType">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['证件类型']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="配偶手机号码">
                      <el-input :readonly="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.orderRelativeInfo.mobile">
                        <i slot="suffix" class="el-input__icon el-icon-view dcrypt-eye" v-if="pageControl.eyes.relative.mobile" @click="encryptionData(encryptionType.relative.mobile, pageData.orderRelativeInfo, encryptionType.relative.eyeOwner)"></i>
                      </el-input>
                      <el-tag v-if="pageData.riskInfo.mobileCheck_s !== null && pageControl.current.operateTypePreview">{{pageData.riskInfo.mobileCheck_s}}</el-tag>
                    </el-form-item>
                    <el-form-item label="配偶现居省/市/区">
                      <el-cascader
                        style="width: 100%"
                        :disabled="pageControl.current.operateTypePreview"
                        size="large"
                        :options="regionDataPlus"
                        v-model="pageHelperData.area.relative.now"></el-cascader>
                    </el-form-item>
                    <el-form-item label="配偶户籍省/市/区">
                      <el-cascader
                        style="width: 100%"
                        :disabled="pageControl.current.operateTypePreview"
                        size="large"
                        :options="regionDataPlus"
                        v-model="pageHelperData.area.relative.home"></el-cascader>
                    </el-form-item>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item label="配偶性别">
                      <el-select :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.orderRelativeInfo.sex">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['性别']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="配偶学历">
                      <el-select :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderRelativeInfo.education">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['学历']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="配偶证件号码">
                      <el-input :readonly="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.orderRelativeInfo.idno">
                        <i slot="suffix" class="el-input__icon el-icon-view dcrypt-eye" v-if="pageControl.eyes.relative.idno" @click="encryptionData(encryptionType.relative.idno, pageData.orderRelativeInfo, encryptionType.relative.eyeOwner)"></i>
                      </el-input>
                    </el-form-item>
                    <el-form-item label="配偶现工作单位名称"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderRelativeInfo.nowCompany"></el-input></el-form-item>
                    <el-form-item label="配偶现居地址"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderRelativeInfo.nowAddress"></el-input></el-form-item>
                    <el-form-item label="配偶户籍地址"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderRelativeInfo.address"></el-input></el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-card>
            <!-- Guarantee Info | guaranteeInfo -->
            <el-card name="GuaranteeInfo" v-if="pageControl.current.hasGuaranteeInfo">
              <div slot="header" class="card-title" @click="cardTitleClickHandler(cardConfig.guaranteeInfo)">
                <bd-card-title :text="cardConfig.guaranteeInfo.title.text" :btn-class="cardConfig.guaranteeInfo.title.btnClass"></bd-card-title>
              </div>
              <div v-show="cardConfig.guaranteeInfo.visible">
                <el-row :gutter="20" type="flex" justify="center">
                  <el-col :span="11">
                    <el-form-item label="担保人姓名"><el-input :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.guaranteeInfo.guaranteeName"></el-input></el-form-item>
                    <el-form-item label="担保人性别">
                      <el-select :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.guaranteeInfo.sex">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['性别']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="与申请人关系">
                      <el-select :disabled="pageControl.current.operateTypePreview" v-model="pageData.guaranteeInfo.relationGFl">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['担保人关系']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="担保人证件类型">
                      <el-select :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.guaranteeInfo.idType">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['证件类型']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="担保人证件号码">
                      <el-input :readonly="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.guaranteeInfo.idno">
                        <i slot="suffix" class="el-input__icon el-icon-view dcrypt-eye" v-if="pageControl.eyes.guarantee.idno" @click="encryptionData(encryptionType.guarantee.idno, pageData.guaranteeInfo, encryptionType.guarantee.eyeOwner)"></i>
                      </el-input>
                    </el-form-item>
                    <el-form-item label="担保人生日">
                      <el-input :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.guaranteeInfo.birth"></el-input>
                    </el-form-item>
                    <el-form-item label="担保人现居住电话">
                      <el-input :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.guaranteeInfo.nowTel"></el-input>
                    </el-form-item>
                    <el-form-item label="担保人学历" v-if="!pageControl.current.operateTypeModify">
                      <el-select :disabled="pageControl.current.operateTypePreview" v-model="pageData.guaranteeInfo.education">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['学历']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="担保人手机号码">
                      <el-input :readonly="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.guaranteeInfo.mobile">
                        <i slot="suffix" class="el-input__icon el-icon-view dcrypt-eye" v-if="pageControl.eyes.guarantee.mobile" @click="encryptionData(encryptionType.guarantee.mobile, pageData.guaranteeInfo, encryptionType.guarantee.eyeOwner)"></i>
                      </el-input>
                      <el-tag v-if="pageData.riskInfo.mobileCheck_g !== null && pageControl.current.operateTypePreview">{{pageData.riskInfo.mobileCheck_g}}</el-tag>
                    </el-form-item>
                    <el-form-item label="担保人从事行业" v-if="!pageControl.current.operateTypeModify">
                      <el-select :disabled="pageControl.current.operateTypePreview" v-model="pageData.guaranteeInfo.nowIndustry">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['从事行业']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="担保人职位" v-if="!pageControl.current.operateTypeModify">
                      <el-select :disabled="pageControl.current.operateTypePreview" v-model="pageData.guaranteeInfo.nowPosition">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['职位']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="担保人收入来源" v-if="!pageControl.current.operateTypeModify"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.guaranteeInfo.incomeSource"></el-input></el-form-item>
                    <el-form-item label="担保人税后月收入" v-if="!pageControl.current.operateTypeModify"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.guaranteeInfo.incomeMonth"><span slot="append">元</span></el-input></el-form-item>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item label="担保人户籍省/市/区">
                      <el-cascader
                        style="width: 100%"
                        :disabled="pageControl.current.operateTypePreview"
                        size="large"
                        :options="regionDataPlus"
                        v-model="pageHelperData.area.guarantee.now"></el-cascader>
                    </el-form-item>
                    <el-form-item label="担保人户籍地址"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.guaranteeInfo.address"></el-input></el-form-item>
                    <el-form-item label="担保人现居省/市/区">
                      <el-cascader
                        style="width: 100%"
                        :disabled="pageControl.current.operateTypePreview"
                        size="large"
                        :options="regionDataPlus"
                        v-model="pageHelperData.area.guarantee.now"></el-cascader>
                    </el-form-item>
                    <el-form-item label="担保人现居住地址"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.guaranteeInfo.nowAddress"></el-input></el-form-item>
                    <el-form-item label="担保人现居住邮编" v-if="!pageControl.current.operateTypeModify">
                      <el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.guaranteeInfo.nowPostalcode"></el-input>
                    </el-form-item>
                    <el-form-item label="担保人现居住时间" v-if="!pageControl.current.operateTypeModify">
                      <el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.guaranteeInfo.nowLivingTime"><span slot="append">年</span></el-input>
                    </el-form-item>
                    <el-form-item label="担保人现工作单位名称"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.guaranteeInfo.nowCompany"></el-input></el-form-item>
                    <el-form-item label="担保人现工作单位省/市/区" v-if="!pageControl.current.operateTypeModify">
                      <el-cascader
                        style="width: 100%"
                        :disabled="pageControl.current.operateTypePreview"
                        size="large"
                        :options="regionDataPlus"
                        v-model="pageHelperData.area.guarantee.work"></el-cascader>
                    </el-form-item>
                    <el-form-item label="担保人现工作单位地址" v-if="!pageControl.current.operateTypeModify">
                      <el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.guaranteeInfo.nowUnitAddress"></el-input>
                    </el-form-item>
                    <el-form-item label="担保人驾驶证号码" v-if="!pageControl.current.operateTypeModify">
                      <el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.guaranteeInfo.firstDriverNo"></el-input>
                    </el-form-item>
                    <el-form-item label="担保人其他月收入" v-if="!pageControl.current.operateTypeModify"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.guaranteeInfo.incomeOth"><span slot="append">元</span></el-input></el-form-item>
                    <el-form-item label="担保人是否有驾驶证" v-if="!pageControl.current.operateTypeModify">
                      <el-select :disabled="pageControl.current.operateTypePreview" v-model="pageData.guaranteeInfo.isDriverLicense">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['是否']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="担保人参加工作时间" v-if="!pageControl.current.operateTypeModify"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.guaranteeInfo.firstWorkTime"></el-input></el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-card>
            <!-- Vehicle Info | orderCarInfo -->
            <el-card name="VehicleInfo">
              <div slot="header" class="card-title" @click="cardTitleClickHandler(cardConfig.vehicleInfo)">
                <bd-card-title :text="cardConfig.vehicleInfo.title.text" :btn-class="cardConfig.vehicleInfo.title.btnClass"></bd-card-title>
              </div>
              <div v-show="cardConfig.vehicleInfo.visible">
                <el-row :gutter="20" type="flex" justify="center">
                  <el-col :span="11">
                    <el-form-item label="品牌"><el-input :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.orderCarInfo.carBrand"></el-input></el-form-item>
                    <el-form-item label="车款年代"><el-input :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.orderCarInfo.carYear"></el-input></el-form-item>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item label="车系"><el-input :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.orderCarInfo.carSeries"></el-input></el-form-item>
                    <el-form-item label="排量/吨位"><el-input :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.orderCarInfo.carDiston"></el-input></el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20" type="flex" justify="center">
                  <el-col :span="11">
                    <el-form-item label="档位">
                      <el-select :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.orderCarInfo.carGearbox">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['汽车档位']" :key="value"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="11"></el-col>
                </el-row>
                <el-row :gutter="20" type="flex" justify="center">
                  <el-col :span="22">
                    <el-form-item label="款式"><el-input :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" type="textarea" :rows="2" v-model="pageData.orderCarInfo.carStyles"></el-input></el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20" type="flex" justify="center">
                  <el-col :span="11">
                    <el-form-item label="新车参考价格">
                      <el-input :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.orderCarInfo.carNewPrice">
                        <span slot="append">元</span>
                      </el-input>
                    </el-form-item>
                    <el-form-item label="二手车车龄">
                      <el-input :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.orderCarInfo.oldCarAge">
                        <span slot="append">月</span>
                      </el-input>
                    </el-form-item>
                    <el-form-item label="车辆识别代号">
                      <el-input :readonly="pageControl.current.operateTypePreview || pageControl.current.operateTypeApprove" v-model="pageData.orderCarInfo.carIdentify">
                        <i slot="suffix" class="el-input__icon el-icon-view dcrypt-eye" v-if="pageControl.eyes.carIdentify" @click="encryptionData(encryptionType.carIdentify, pageData.orderCarInfo)"></i>
                      </el-input>
                      <el-button type="primary" size="mini" v-if="pageControl.current.operateTypeModify" @click="showVinInfoDialog">车300车型识别</el-button>
                    </el-form-item>
                    <el-form-item label="VIN码解析车型" prop="orderCarInfo.vinIdentifyChe300">
                      <el-input :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.orderCarInfo.vinIdentifyChe300"></el-input>
                    </el-form-item>
                    <el-form-item label="过户次数" prop="orderCarInfo.transferCnt">
                      <el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderCarInfo.transferCnt"></el-input>
                    </el-form-item>
                    <el-form-item label="汽车之家评估价">
                      <el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderCarInfo.carHomePrice">
                        <span slot="append">元</span>
                      </el-input>
                    </el-form-item>
                    <el-form-item label="发动机号"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderCarInfo.engineNo"></el-input></el-form-item>
                    <el-form-item label="燃料类型">
                      <el-select :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderCarInfo.fuelType">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['燃料类型']" :key="value"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="二手车卖方姓名"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderCarInfo.carSaleName"></el-input></el-form-item>
                    <el-form-item label="评估公司" v-if="!pageControl.current.operateTypeModify">
                      <el-select :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderCarInfo.measureCompany">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['评估公司']" :key="value"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="评估公证等其他费用">
                      <el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderCarInfo.notarizationFee">
                        <span slot="append">元</span>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item label="车辆新旧" v-if="!pageControl.current.operateTypeModify">
                      <el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderCarInfo.isOldName"></el-input>
                    </el-form-item>
                    <el-form-item label="二手车里程数" prop="orderCarInfo.carMiles">
                      <el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderCarInfo.carMiles"><span slot="append">公里</span></el-input>
                    </el-form-item>
                    <el-form-item label="二手车车况" prop="orderCarInfo.aCarCondtion">
                      <el-select :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderCarInfo.aCarCondtion">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['车况']" :key="value"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="二手车评估价">
                      <el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderCarInfo.aCarPrice" @change="handleACarPriceChange">
                        <span slot="append">元</span>
                      </el-input>
                      <el-button type="primary" size="mini" v-if="pageControl.current.operateTypeModify" @click="showEvaluationPriceDialog">车辆估值</el-button>
                    </el-form-item>
                    <el-form-item label="二手车调整价">
                      <el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderCarInfo.aCarPriceChange">
                        <span slot="append">元</span>
                      </el-input>
                    </el-form-item>
                    <el-form-item label="首次上牌时间" prop="orderCarInfo.carFirstBook">
                      <el-date-picker
                        disabled
                        style="width: 100%"
                        v-model="pageData.orderCarInfo.carFirstBook"
                        value-format="timestamp"
                        type="date"
                        placeholder="请选择"
                        format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="车辆颜色" prop="orderCarInfo.carColor">
                      <el-select :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderCarInfo.carColor">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['车辆颜色']" :key="value"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="车辆用途">
                      <el-select :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderCarInfo.purpose">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['车辆用途']" :key="value"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="二手车卖方身份证号">
                      <el-input :readonly="pageControl.current.operateTypePreview" v-model="pageData.orderCarInfo.carSaleIdno">
                        <i slot="suffix" class="el-input__icon el-icon-view dcrypt-eye" v-if="pageControl.eyes.carSaleIdno" @click="encryptionData(encryptionType.carSaleIdno, pageData.orderCarInfo)"></i>
                      </el-input>
                      <el-tag type="info">(或组织机构代码证)</el-tag>
                    </el-form-item>
                    <el-form-item label="工行车辆评估价" v-if="!pageControl.current.operateTypeModify">
                      <el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderCarInfo.icbcAssessmentPrices">
                        <span slot="append">元</span>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-card>
            <!-- Loan Info | orderLoanInfo -->
            <el-card name="LoanInfo">
              <div slot="header" class="card-title" @click="cardTitleClickHandler(cardConfig.loanInfo)">
                <bd-card-title :text="cardConfig.loanInfo.title.text" :btn-class="cardConfig.loanInfo.title.btnClass"></bd-card-title>
              </div>
              <div v-show="cardConfig.loanInfo.visible">
                <el-row :gutter="20" type="flex" justify="center">
                  <el-col :span="11">
                    <el-form-item label="实际销售价"><el-input disabled v-model="pageData.orderLoanInfo.salePrice"><span slot="append">元</span></el-input></el-form-item>
                    <el-form-item label="是否提供房产">
                      <el-select disabled v-model="pageData.orderLoanInfo.isHouse">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['是否']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="车类">
                      <el-select disabled v-model="pageData.orderLoanInfo.isLcv">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['车类']" :key="value"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="还款期限">
                      <el-select disabled v-model="pageData.orderLoanInfo.aLoanPeriods">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['还款期限']" :key="value"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="GPS档位">
                      <el-select disabled v-model="pageData.orderLoanInfo.gpsLevel">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['GPS档位']" :key="value"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="GPS是否已安装">
                      <el-select disabled v-model="pageData.orderLoanInfo.isGps">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['是否']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="GPS安装个数"><el-input disabled v-model="pageData.orderLoanInfo.gpsCount"></el-input></el-form-item>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item label="车辆贷款金额"><el-input disabled v-model="pageData.orderLoanInfo.aCarloanAmount"><span slot="append">元</span></el-input></el-form-item>
                    <el-form-item label="利率档位">
                      <el-select disabled v-model="pageData.orderLoanInfo.rateLevel">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['利率档位']" :key="value"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="保险贷款金额"><el-input disabled v-model="pageData.orderLoanInfo.aSecureFee"><span slot="append">元</span></el-input></el-form-item>
                    <el-form-item label="月供(仅供参考)">
                      <el-input disabled v-model="pageHelperData.form.monthPay">
                        <el-button slot="append" type="primary" plain size="mini" @click="handleMonthPayClick">计算</el-button>
                      </el-input>
                    </el-form-item>
                    <el-form-item label="贷款年利率"><el-input disabled v-model="pageData.orderLoanInfo.aLoanRate"><span slot="append">%</span></el-input></el-form-item>
                    <el-form-item label="GPS费用"><el-input disabled v-model="pageData.orderLoanInfo.gpsFee"></el-input></el-form-item>
                    <el-form-item label="GPS属性"><el-input disabled v-model="pageData.orderLoanInfo.gpsPro"></el-input></el-form-item>
                  </el-col>
                </el-row>
                <el-row type="flex" justify="center">
                  <el-col :span="22">
                    <el-form-item label="GPS供应商与设备ID"><el-input disabled v-model="pageData.orderLoanInfo.gpsDealerNo" type="textarea" :rows="2"></el-input></el-form-item>
                  </el-col>
                </el-row>
                <el-row type="flex" justify="center">
                  <el-col :span="11">
                    <el-form-item label="GPS费用是否贷款">
                      <el-select disabled v-model="pageData.orderLoanInfo.isGpsLoan">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['是否']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="首付款"><el-input disabled v-model="pageData.orderLoanInfo.aInitPayment"></el-input></el-form-item>
                    <el-form-item label="平台费率"><el-input disabled v-model="pageData.orderLoanInfo.aComRate"><span slot="append">%</span></el-input></el-form-item>
                    <el-form-item label="人身保险档位">
                      <el-select disabled v-model="pageData.orderLoanInfo.lifeInsuranceLevel">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['人身保险档位']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="续保押金"><el-input disabled v-model="pageData.orderLoanInfo.insuranceDeposit"></el-input></el-form-item>
                    <el-form-item label="人身保险公司">
                      <el-select disabled v-model="pageData.orderLoanInfo.insuranceCompany">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['保险公司']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="渠道验证结果"><el-input disabled v-model="pageData.orderLoanInfo.chApprovalStatus"></el-input></el-form-item>
                    <el-form-item label="过户凭证">
                      <el-select disabled v-model="pageData.orderLoanInfo.transferVoucher">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['过户凭证']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="还款人证件号码">
                      <el-input :readonly="pageControl.current.operateTypePreview" v-model="pageData.orderLoanInfo.repAccountIdno">
                        <i slot="suffix" class="el-input__icon el-icon-view dcrypt-eye" v-if="pageControl.eyes.repAccountIdno" @click="encryptionData(encryptionType.repAccountIdno, pageData.orderLoanInfo)"></i>
                      </el-input>
                    </el-form-item>
                    <el-form-item label="还款借记卡户名"><el-input disabled v-model="pageData.orderLoanInfo.repAccountName"></el-input></el-form-item>
                    <el-form-item label="还款借记卡号">
                      <el-input :readonly="pageControl.current.operateTypePreview" v-model="pageData.orderLoanInfo.repAccountNo">
                        <i slot="suffix" class="el-input__icon el-icon-view dcrypt-eye" v-if="pageControl.eyes.repAccountNo" @click="encryptionData(encryptionType.repAccountNo, pageData.orderLoanInfo)"></i>
                      </el-input>
                    </el-form-item>
                    <el-form-item label="还款借记卡开户行"><el-input disabled v-model="pageData.orderLoanInfo.repAccountBank"></el-input></el-form-item>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item label="总贷款金额"><el-input disabled v-model="pageData.orderLoanInfo.aLoanAmount"><span slot="append">（车辆+其他）</span></el-input></el-form-item>
                    <el-form-item label="首付款比例"><el-input disabled v-model="pageData.orderLoanInfo.aInitScale"><span slot="append">%</span></el-input></el-form-item>
                    <el-form-item label="平台费"><el-input disabled v-model="pageData.orderLoanInfo.aComFee"></el-input></el-form-item>
                    <el-form-item label="人身保险费率"><el-input disabled v-model="pageData.orderLoanInfo.alifeInsuranceRate"><span slot="append">%</span></el-input></el-form-item>
                    <el-form-item label=""></el-form-item>
                    <el-form-item label="活体检测分值"><el-input disabled v-model="pageData.orderLoanInfo.htScore"></el-input></el-form-item>
                    <el-form-item label="账户管理费"><el-input disabled v-model="pageData.orderLoanInfo.accountFee"></el-input></el-form-item>
                    <el-form-item label="异地购车补充资料">
                      <el-select disabled v-model="pageData.orderLoanInfo.nonLocalMaterial">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['异地购车补充资料']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="银行卡预留手机">
                      <el-input :readonly="pageControl.current.operateTypePreview" v-model="pageData.orderLoanInfo.repAccountMobile">
                        <i slot="suffix" class="el-input__icon el-icon-view dcrypt-eye" v-if="pageControl.eyes.repAccountMobile" @click="encryptionData(encryptionType.repAccountMobile, pageData.orderLoanInfo)"></i>
                      </el-input>
                    </el-form-item>
                    <el-form-item label="产品贴息金额"><el-input disabled v-model="pageData.orderLoanInfo.discountE"></el-input></el-form-item>
                    <el-form-item label="实际贴息金额"><el-input disabled v-model="pageData.orderLoanInfo.discountTrueE"></el-input></el-form-item>
                    <el-form-item label="贴息后贷款利率"><el-input disabled v-model="pageData.orderLoanInfo.disaRate"><span slot="append">%</span></el-input></el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-card>
            <!-- Public Card Info | caAppCompanyInfo -->
            <el-card name="PublicCardInfo" v-if="pageControl.current.isCompanyLicense && !pageControl.current.operateTypeModify">
              <div slot="header" class="card-title" @click="cardTitleClickHandler(cardConfig.publicCardInfo)">
                <bd-card-title :text="cardConfig.publicCardInfo.title.text" :btn-class="cardConfig.publicCardInfo.title.btnClass"></bd-card-title>
              </div>
              <div v-show="cardConfig.publicCardInfo.visible">
                <el-row :gutter="20" type="flex" justify="center">
                  <el-col :span="11">
                    <el-form-item label="注册公司名称"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.caAppCompanyInfo.registeredCompanyName"></el-input></el-form-item>
                    <el-form-item label="注册公司地址"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.caAppCompanyInfo.registeredCompanyAddress"></el-input></el-form-item>
                    <el-form-item label="注册公司电话"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.caAppCompanyInfo.registeredCompanyTel"></el-input></el-form-item>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item label="统一社会信用代码"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.caAppCompanyInfo.registeredCompanyCode"></el-input></el-form-item>
                    <el-form-item label="公司法人"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.caAppCompanyInfo.legalName"></el-input></el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-card>
            <!-- PuFa Info | spdBusinessInfo -->
            <el-card name="PuFaInfo">
              <div slot="header" class="card-title" @click="cardTitleClickHandler(cardConfig.puFaInfo)">
                <bd-card-title :text="cardConfig.puFaInfo.title.text" :btn-class="cardConfig.puFaInfo.title.btnClass"></bd-card-title>
              </div>
              <div v-show="cardConfig.puFaInfo.visible">
                <el-row :gutter="20" type="flex" justify="center">
                  <el-col :span="11">
                    <el-form-item label="营销人员代码"><el-input :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.spdBusinessInfo.marketerCode"></el-input></el-form-item>
                    <el-form-item label="浦发信用卡产品">
                      <el-select :disabled="pageControl.current.operateTypePreview" v-model="pageData.spdBusinessInfo.cardProductCode">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['浦发信用卡产品']" :key="value"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="推荐人代码"><el-input :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.spdBusinessInfo.referenceCode"></el-input></el-form-item>
                    <el-form-item label="领用合约代码"><el-input :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.spdBusinessInfo.applicationagreementbarcode"></el-input></el-form-item>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item label="申请人邮箱"><el-input :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.spdBusinessInfo.email"></el-input></el-form-item>
                    <el-form-item label="申请人开卡城市">
                      <el-select :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.spdBusinessInfo.cityCodeStr">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['市']" :key="value"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="推荐人机构代码"><el-input :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.spdBusinessInfo.referenceJgcode"></el-input></el-form-item>
                    <el-form-item label="现工作单位固话"><el-input :disabled="pageControl.current.operateTypePreview || pageControl.current.operateTypeModify" v-model="pageData.spdBusinessInfo.workTel"></el-input></el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-card>
            <!-- Grand Account Info | orderLoanAccountInfo -->
            <el-card name="GrandAccountInfo" v-if="!pageControl.current.operateTypeModify">
              <div slot="header" class="card-title" @click="cardTitleClickHandler(cardConfig.grantAccountInfo)">
                <bd-card-title :text="cardConfig.grantAccountInfo.title.text" :btn-class="cardConfig.grantAccountInfo.title.btnClass"></bd-card-title>
              </div>
              <div v-show="cardConfig.grantAccountInfo.visible">
                <el-row :gutter="20" type="flex" justify="center">
                  <el-col :span="11">
                    <el-form-item label="收款账户姓名"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderLoanAccountInfo.recAccountName"></el-input></el-form-item>
                    <el-form-item label="收款借记卡号">
                      <el-input :readonly="pageControl.current.operateTypePreview" v-model="pageData.orderLoanAccountInfo.recAccountNo">
                        <i slot="suffix" class="el-input__icon el-icon-view dcrypt-eye" v-if="pageControl.eyes.recAccountNo" @click="encryptionData(encryptionType.recAccountNo, pageData.orderLoanAccountInfo)"></i>
                      </el-input>
                    </el-form-item>
                    <el-form-item label="收款开户银行"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderLoanAccountInfo.recAccountBank2"></el-input></el-form-item>
                    <el-form-item label="收款开户行所在省/市">
                      <el-cascader
                        style="width: 100%"
                        disabled
                        size="large"
                        :options="provinceAndCityData"
                        v-model="pageHelperData.area.loanAccount"></el-cascader>
                    </el-form-item>
                    <el-form-item label="银行联行号"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderLoanAccountInfo.branchBankCode"></el-input></el-form-item>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item label="收款账户证件号码">
                      <el-input :readonly="pageControl.current.operateTypePreview" v-model="pageData.orderLoanAccountInfo.recAccountCard">
                        <i slot="suffix" class="el-input__icon el-icon-view dcrypt-eye" v-if="pageControl.eyes.recAccountCard" @click="encryptionData(encryptionType.recAccountCard, pageData.orderLoanAccountInfo)"></i>
                      </el-input>
                    </el-form-item>
                    <el-form-item label="账户类型">
                      <el-select :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderLoanAccountInfo.accountType">
                        <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['账户类型']" :key="key"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="收款开户支行"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderLoanAccountInfo.recAccountBank"></el-input></el-form-item>
                    <el-form-item label="银行预留手机号"><el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderLoanAccountInfo.recordMobile"></el-input></el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-card>
            <!-- Remarks 补充说明 -->
            <el-card>
              <el-row type="flex" justify="center">
                <el-col :span="22">
                  <el-form-item label="补充说明"><el-input disabled v-model="pageData.remarks" type="textarea" :rows="2"></el-input></el-form-item>
                </el-col>
              </el-row>
              <div v-if="pageControl.current.operateTypeModify">
                <el-row type="flex" justify="center">
                  <el-col :span="22">
                    <el-form-item label="复审审批备注"><el-input v-model="pageData.orderBaseInfo.loanRemarks" type="textarea" :rows="4"></el-input></el-form-item>
                  </el-col>
                </el-row>
                <el-row type="flex" justify="center">
                  <el-col :span="22">
                    <el-form-item label="复议审批备注"><el-input v-model="pageData.orderBaseInfo.fyRemarks" type="textarea" :rows="4"></el-input></el-form-item>
                  </el-col>
                </el-row>
                <el-row type="flex" justify="center">
                  <el-col :span="22">
                    <el-form-item label="系统审批备注">
                      <el-input disabled v-model="pageData.orderBaseInfo.sysaRemarks" type="textarea" :rows="4"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-card>
          </el-form>
          <!-- 根据操作人类型判断是否显示第三方检查结果，类型为审批人：显示；类型为运营人员：隐藏 -->
          <!-- Third-party Check Info -->
          <el-card name="ThirdPartyCheckInfo" v-if="pageControl.current.identityApprover && pageControl.current.operateTypePreview">
            <div slot="header" class="card-title" @click="cardTitleClickHandler(cardConfig.thirdPartyCheckResult)">
              <bd-card-title :text="cardConfig.thirdPartyCheckResult.title.text" :btn-class="cardConfig.thirdPartyCheckResult.title.btnClass"></bd-card-title>
            </div>
            <div v-show="cardConfig.thirdPartyCheckResult.visible">
              <el-table :data="pageData.riskInfo.data" border size="mini">
                <el-table-column label="检查结果展示时间">
                  <template slot-scope="scope">{{pageData.riskInfo.lastTime | formatterDate}}</template>
                </el-table-column>
                <el-table-column label="姓名">
                  <template slot-scope="scope">{{pageData.riskInfo.name}}</template>
                </el-table-column>
                <el-table-column prop="orgName" label="服务商"></el-table-column>
                <el-table-column label="检查项">
                  <template slot-scope="scope"><el-tag type="success" size="mini">主贷人</el-tag></template>
                </el-table-column>
                <el-table-column prop="tmp" label="结果">
                  <template slot-scope="scope">
                    <a v-bind:href="scope.row.reportUrl" target="_blank"><el-button type="text" size="mini">{{scope.row.score}}</el-button></a>
                  </template>
                </el-table-column>
                <el-table-column prop="msg" label="备注" width="180px"></el-table-column>
              </el-table>
            </div>
          </el-card>
          <!-- Credit Report Attachments | creditAnnexInfo -->
          <el-card name="CreditReportAttachments" v-if="pageControl.current.operateTypePreview">
            <div slot="header" class="card-title" @click="cardTitleClickHandler(cardConfig.creditReportAttachmentsInfo)">
              <bd-card-title :text="cardConfig.creditReportAttachmentsInfo.title.text" :btn-class="cardConfig.creditReportAttachmentsInfo.title.btnClass"></bd-card-title>
            </div>
            <div v-show="cardConfig.creditReportAttachmentsInfo.visible">
              <el-table :data="pageData.creditAnnexInfo.caAppAnnexDTOList" border size="mini">
                <el-table-column prop="userName" label="上传人"></el-table-column>
                <el-table-column prop="annexType" label="附件类型">
                  <template slot-scope="scope">{{scope.row.annexType | fAttachmentType}}</template>
                </el-table-column>
                <el-table-column prop="annexName" label="附件名称">
                  <template slot-scope="scope">
                    <a :href="scope.row.annexAddress" target="_blank">{{scope.row.annexName}}</a>
                  </template>
                </el-table-column>
                <el-table-column prop="createTime" label="上传时间">
                  <template slot-scope="scope">{{scope.row.createTime | formatterDate}}</template>
                </el-table-column>
              </el-table>
              <!-- 根据操作人类型判断是否显示审批备注，类型为审批人：显示；类型为运营人员：隐藏 -->
              <el-form label-width="120px" style="margin-top: 10px;" v-if="pageControl.current.identityApprover">
                <el-row type="flex" justify="center">
                  <el-col :span="22">
                    <el-form-item label="复审审批备注">
                      <el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.loanRemarks" type="textarea" :rows="4"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row type="flex" justify="center">
                  <el-col :span="22">
                    <el-form-item label="复议审批备注">
                      <el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.fyRemarks" type="textarea" :rows="4"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row type="flex" justify="center">
                  <el-col :span="22">
                    <el-form-item label="系统审批备注">
                      <el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.sysaRemarks" type="textarea" :rows="4"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row type="flex" justify="center">
                  <el-col :span="22">
                    <el-form-item label="签约审批备注">
                      <el-input :disabled="pageControl.current.operateTypePreview" v-model="pageData.orderBaseInfo.bloanRemarks" type="textarea" :rows="4"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </el-card>
          <!-- Order Attachments | caAppAnnexDTOs -->
          <el-card name="OrderAttachments" v-if="pageControl.current.operateTypePreview">
            <div slot="header" class="card-title" @click="cardTitleClickHandler(cardConfig.orderAttachmentsInfo)">
              <bd-card-title :text="cardConfig.orderAttachmentsInfo.title.text" :btn-class="cardConfig.orderAttachmentsInfo.title.btnClass"></bd-card-title>
            </div>
            <div v-show="cardConfig.orderAttachmentsInfo.visible">
              <el-table :data="pageData.caAppAnnexDTOs" border size="mini">
                <el-table-column prop="userName" label="上传人"></el-table-column>
                <el-table-column prop="annexType" label="附件类型">
                  <template slot-scope="scope">{{scope.row.annexType | fAttachmentType}}</template>
                </el-table-column>
                <el-table-column prop="annexName" label="附件名称">
                  <template slot-scope="scope">
                    <a :href="scope.row.annexAddress" target="_blank">{{scope.row.annexName}}</a>
                  </template>
                </el-table-column>
                <el-table-column prop="createTime" label="上传时间">
                  <template slot-scope="scope">{{scope.row.createTime | formatterDate}}</template>
                </el-table-column>
              </el-table>
            </div>
          </el-card>
        </div>

        <!-- Approval History | caAppApprovals -->
        <el-card name=" ApprovalHistory" v-if="!pageControl.current.operateTypeModify">
          <div slot="header" class="card-title" @click="cardTitleClickHandler(cardConfig.approvalHistory)">
            <bd-card-title :text="cardConfig.approvalHistory.title.text" :btn-class="cardConfig.approvalHistory.title.btnClass"></bd-card-title>
          </div>
          <div v-show="cardConfig.approvalHistory.visible">
            <el-table :data="pageData.caAppApprovals" border size="mini">
              <!-- 根据操作人类型判断是否显示审批人名称，类型为审批人：显示；类型为运营人员：隐藏 -->
              <el-table-column prop="userName" label="审批人名称" v-if="pageControl.current.identityApprover"></el-table-column>
              <el-table-column prop="status" label="审批流程阶段">
                <template slot-scope="scope">{{scope.row.status | fApplyStatus}}</template>
              </el-table-column>
              <el-table-column prop="flowName" label="审批流程名称"></el-table-column>
              <el-table-column prop="type" label="审批状态"></el-table-column>
              <el-table-column prop="remarks" label="审批备注"></el-table-column>
              <el-table-column prop="approvalTime" label="审批日期">
                <template slot-scope="scope">{{scope.row.approvalTime | formatterDate}}</template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-main>
    </el-container>

    <!-- back & bottom -->
    <back-top></back-top>
    <to-bottom></to-bottom>

    <!-- favorite -->
    <el-tooltip content="面签字段" placement="left" v-if="pageControl.current.approvalStepContract">
      <bd-favorite-button @click="handleShowFavorite"></bd-favorite-button>
    </el-tooltip>
  </el-row>
</template>

<script>
import BdCardTitle from '../../components/appinfo/bdCardTitle'
import BackTop from '../../components/common/BackTop'
import {orderDetailsData} from '../../assets/js/page/approval/orderDetails.vue.data'
import {orderDetailsMethods} from '../../assets/js/page/approval/orderDetails.vue.methods'
import UploadDialog from '../../components/bdUploadFileDialog'
import ToBottom from '../../components/common/ToBottom'
import BdFavoriteButton from '../../components/appinfo/bdFavoriteButton'

export default {
  name: 'orderDetails',
  components: {BdFavoriteButton, ToBottom, BdCardTitle, BackTop, UploadDialog},
  data () {
    return orderDetailsData
  },
  methods: orderDetailsMethods,
  created () {
    this.initOrderDetails()
  }
}
</script>

<style scoped>
@import "../../assets/css/base/order-details.css";
</style>



// WEBPACK FOOTER //
// src/pages/approval/orderDetails.vue